import {useRoutes} from 'react-router';
import Home from './pages/Home.js';
import Meeting from './pages/Meeting.js';
import NumerologyCalculator from './pages/NumerologyCalculator.js';
import NotFound from './pages/NotFound.js';
import TarotmailCustomer from './pages/tarotmail/TarotmailCustomer.js';
import TarotmailCustomerUnsubscribe from './pages/tarotmail/TarotmailCustomerUnsubscribe.js';
import TarotmailStudent from './pages/tarotmail/TarotmailStudent.js';
import Counseling from './pages/Counseling.js';
import Services from './pages/Services.js';
import StudentArea from './pages/StudentArea.js';
import Contact from './pages/Contact.js';
import TarotSpread from './pages/TarotSpread.js';
import PrivateLessons from './pages/PrivateLessons.js';
import Workshops from './pages/Workshops.js';
import AdminBlog from './pages/AdminBlog.js';
import TarotSpreadPage from './pages/TarotSpreadPage.js';
import Webrtc from './pages/Webrtc.js';
import WebrtcParticipant from './pages/WebrtcParticipant.js';
import AdminUsers from './pages/AdminUsers.js';
import TarotmailCustomerSimona from './pages/tarotmail/TarotmailCustomerSimona.js';
import Terms from './pages/legal/Terms.js';
import PrivacyPolicy from './pages/legal/PrivacyPolicy.js';
import Accessibility from './pages/legal/Accessibility.js';
import AdminMetrics from './pages/AdminMetrics.js';
import PasswordReset from './pages/PasswordReset.js';

// TODO: IMPLEMENT REACT LAZY
export const useSiteRoutes = ()=>useRoutes([
    {path: '/', Component: Home},
    {path: '/services', Component: Services},
    {path: '/contact', Component: Contact},
    {path: '/meeting', Component: Meeting},
    {path: '/counseling', Component: Counseling},
    {path: '/private_lessons', Component: PrivateLessons},
    {path: '/workshops', Component: Workshops},
    {path: '/numerology_calculator', Component: NumerologyCalculator},
    {path: '/student_area', Component: StudentArea},
    {path: '/tarotmail/student', Component: TarotmailStudent},
    {path: '/tarotmail', Component: TarotmailCustomer},
    {path: '/tarotmail/simona', Component: TarotmailCustomerSimona},
    {path: '/tarotmail/unsubscribe', Component: TarotmailCustomerUnsubscribe},
    {path: '/tarotspread', Component: TarotSpread},
    {path: '/tarot-spread', Component: TarotSpreadPage},
    {path: '/admin/blog', Component: AdminBlog},
    {path: '/admin/users', Component: AdminUsers},
    {path: '/admin/metrics', Component: AdminMetrics},
    {path: '/webrtc_host', Component: Webrtc},
    {path: '/webrtc_participant', Component: WebrtcParticipant},
    {path: '/terms', Component: Terms},
    {path: '/privacy-policy', Component: PrivacyPolicy},
    {path: '/accessibility', Component: Accessibility},
    {path: '/password_reset', Component: PasswordReset},
    {path: '*', Component: NotFound},
]);
